import { IAuthUser } from 'auth/types';
import { ICustomerQuote, IQuotePart } from 'quotes/types';

export const AlternateVersionHelper = {
  isAlternateVersionEnabled: ({
    user,
    quote,
    quotePart,
  }: {
    quote?: ICustomerQuote | null;
    user?: IAuthUser | null;
    quotePart?: IQuotePart | null;
  }): boolean => {
    if (quote) {
      return Boolean(quote?.alternateVersionEnabled);
    }

    if (quotePart) {
      return Boolean(quotePart?.alternateVersionEnabled);
    }

    return Boolean(user?.alternateVersionEnabled);
  },

  isDdpOrderIntegrationEnabled: ({ user }: { user: IAuthUser }): boolean =>
    user.companySettings?.ddpOrderIntegrationEnabled,
};
